// List Data
const ADMINPP_LIST_REQUEST = 'ADMINPP_LIST_REQUEST';
const ADMINPP_LIST_SUCCESS = 'ADMINPP_LIST_SUCCESS';
const ADMINPP_LIST_FAILURE = 'ADMINPP_LIST_FAILURE';

const ADMINPP_ADD_REQUEST = 'ADMINPP_ADD_REQUEST';
const ADMINPP_ADD_SUCCESS = 'ADMINPP_ADD_SUCCESS';
const ADMINPP_ADD_FAILURE = 'ADMINPP_ADD_FAILURE';

const ADMINPP_EDIT_REQUEST = 'ADMINPP_EDIT_REQUEST';
const ADMINPP_EDIT_SUCCESS = 'ADMINPP_EDIT_SUCCESS';
const ADMINPP_EDIT_FAILURE = 'ADMINPP_EDIT_FAILURE';

const ADMINPP_GETID_REQUEST = 'ADMINPP_GETID_REQUEST';
const ADMINPP_GETID_SUCCESS = 'ADMINPP_GETID_SUCCESS';
const ADMINPP_GETID_FAILURE = 'ADMINPP_GETID_FAILURE';

const ADMIN_STATUS_REQUEST = 'ADMIN_STATUS_REQUEST';
const ADMINPP_STATUS_SUCCESS = 'ADMINPP_STATUS_SUCCESS';
const ADMINPP_STATUS_FAILURE = 'ADMINPP_STATUS_FAILURE';

const ADMIN_DELETE_REQUEST = 'ADMIN_DELETE_REQUEST';
const ADMINPP_DELETE_SUCCESS = 'ADMINPP_DELETE_SUCCESS';
const ADMINPP_DELETE_FAILURE = 'ADMINPP_DELETE_FAILURE';

const ADMINPPLIST='ADMINPPLIST';

export {
    ADMINPPLIST, ADMINPP_LIST_REQUEST, ADMINPP_LIST_SUCCESS, ADMINPP_LIST_FAILURE,ADMINPP_ADD_REQUEST,ADMINPP_ADD_SUCCESS,ADMINPP_ADD_FAILURE,
    ADMINPP_EDIT_REQUEST,ADMINPP_EDIT_SUCCESS,ADMINPP_EDIT_FAILURE,ADMINPP_GETID_REQUEST,ADMINPP_GETID_SUCCESS,ADMINPP_GETID_FAILURE,
    ADMIN_STATUS_REQUEST,ADMINPP_STATUS_SUCCESS,ADMINPP_STATUS_FAILURE,ADMIN_DELETE_REQUEST,ADMINPP_DELETE_SUCCESS,ADMINPP_DELETE_FAILURE
};
